import ToDoSite from '../assets/to-do-site.png';
import CMS from '../assets/cms-site.png'

export const projectData = [
    {
        title: "Check List",
        description: "A React Site with Node.js for creating a Checklist.",
        image: ToDoSite, // Replace with an actual image URL or local image
        link: "https://main--golden-panda-a78175.netlify.app"
    },
    {
        title: "CMS-1500",
        description: `Website created with raw HTML, CSS, and JavaScript.`,
        image: CMS, // Replace with an actual image URL or local image
        link: "https://www.form-ins.com"
    }
];
